$bog_fragile_demo_outer_widget1 $mol_view
	city \Москва
	sub / <= city
